<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-2 pb-4 mb-3 border-bottom">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dashboard</span>
        <h3 class="page-title">Calendar</h3>
      </d-col>
      <d-col no-gutters class="d-flex ml-auto my-auto col-sm-4">
          <d-button class="mx-auto ml-sm-suto mr-sm-0" pill @click="redirectUser()"><i class="material-icons">add</i> New Event</d-button>
      </d-col>
    </d-row>
    <d-modal v-if="showModal" @close="handleClose">
        <d-modal-header>
            <d-modal-title>Edit Your Scedule</d-modal-title>
        </d-modal-header>
        <d-col><span>ID: {{ id }}</span></d-col>
        <d-modal-body>
          <d-container fluid>
            <d-row class="my-1" v-for="type in inputTypes" :key="type">
              Start time:
              <d-form-input :id="`type-${type}`" :type="type" v-model="beginTime"></d-form-input>
              End time:
              <d-form-input :id="`type-${type}`" :type="type" v-model="endTime"></d-form-input>
            </d-row>
          </d-container>
          Participiants:
          <d-input type="number" v-model="participant" class="mb-2"/>
          <d-btn pill @click="updateTimeslot()">Update</d-btn>
          <d-btn pill theme="danger" style="margin: 5px" @click="deleteTimeslot()">Delete</d-btn>
          </d-modal-body>
    </d-modal>
    <FullCalendar :options="calendarOptions" />
  </d-container>
</template>
<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from "axios";
 
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      showModal: false,
      inputTypes: ['time'],
      info: [],
      beginTime: "",
      endTime: "",
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        //dateClick: this.handleDateClick,
        eventClick: this.eventClick,
        events: [],
      },
    };
  },
  mounted: function () {
    this.onpageload();
  },
  methods: {
    async onpageload() {
      await axios
        .get(process.env.VUE_APP_API+"api/staff/TimeSlot")
        .then((response) => {
          this.timeslot = response.data.result;
          this.timeslot.forEach(element => {
            element.result.forEach(x=>{
              var month = x.date.split('-')[1];
              month = month.length==1? '0'+ month : month;
              var date = x.date.split('-')[0]+ "-" + month + "-"+ x.date.split('-')[2];
              this.calendarOptions.events.push({groupId: `${x.id}`, title: `${x.startTime} - ${x.endTime}`, start: date });
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteTimeslot() {
      axios
        .delete(process.env.VUE_APP_API+"api/staff/TimeSlot", {
          data:{
            timeslotIds: [this.id]
          },
        })
        .then((response) => {
          console.log(response.data.result);
        })
    },
    updateTimeslot() {
      axios
        .put(process.env.VUE_APP_API+"api/staff/TimeSlot/"+this.id, {
            beginTime: this.info.date + "T" + this.beginTime + ":00.000Z",
            endTime: this.info.date + "T" + this.endTime + ":00.000Z",
            totalAvailabele: this.participant
        })
        .then((response) => {
          console.log(response.data.result);
        })
    },
    handleDateClick: function (arg) {
      alert("date click! " + arg.dateStr);
    },
    eventClick: function(info) {
      axios
        .get(process.env.VUE_APP_API+"api/public_user/TimeSlot/" + info.event.groupId)
        .then((response) => {
          this.info = response.data.result;
          this.showModal = true;
          this.id = info.event.groupId;
          this.startTime = this.info.startTime;
          this.endTime = this.info.endTime;
          this.participant = this.info.total;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleClose() {
        this.showModal = false
    },
    redirectUser() {
      if (1 == 1) {
        this.$router.push({
          name: "set-time-slot",
        });
      }
    },
  },
};
</script>

